export default __webpack_public_path__ + "static/media/linked-in.1e3abda9.svg";